<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <OrfEval orfName="gender"
             :orfType="registeringPersonType">
        <template v-slot:default="{required}">
            <OrfEval :doNotHide="true"
                     orfName="name"
                     :orfType="registeringPersonType">
                <template v-slot:default="{hidden}">
                    <CardSelect type="radio"
                                v-model="person.gender"
                                :required="required"
                                :name="$t('eventRegistration.person.salutation')"
                                :fixedWidthSm="true">
                        <CardSelectItem v-for="gender in allowedGenders"
                                        :value="gender.value"
                                        :key="gender.value"
                                        :icon="gender.value && genderIcons[gender.value]">
                            {{ gender.label }}
                        </CardSelectItem>
                    </CardSelect>
                </template>
            </OrfEval>
        </template>
    </OrfEval>
</template>

<script>
import OrfEval from "@/components/pages/registration/OrfEval";
import formSelectChoiceMixin from "@/mixins/registration/formSelectChoiceMixin";
import registrationPersonMixin from "@/mixins/registration/registrationPersonMixin";
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

export default {
    name: "InvoiceRecipientGender",
    mixins: [registrationPersonMixin, formSelectChoiceMixin, registrationOnlineRegistrationFieldsMixin],
    components: { OrfEval},
    props: {
        registeringPersonType: {
            required: true,
            type: String,
            description: "participant or invoiceRecipient"
        }
    },
    computed: {
        allowedGenders() {
            if (!this.genders) return []
            return this.genders.filter(gender => this.diverseSalutation || gender.value !== 'd')
        },
        genderIcons() {
            return {
                'w': 'venus',
                'm': 'mars',
                'd': 'neuter'
            }
        }
    },
    watch: {
        'person.salutation': {
            handler(value) {
                if (value && !this.person?.gender) {
                    let salutationGender = this.salutations?.find(salutation => salutation.title === value)
                    this.$set(this.person, 'gender', salutationGender?.gender ?? null)
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
